import angular from 'angular';
import moment from 'angular-moment';

import MathUtil from '../../../components/logic/math_util/math_util';

import './power-stat-table.css';

export class PowerStatTableController {
  /*@ngInject*/
  constructor($scope, $filter, moment, MathUtil) {
    this.moment = moment;
    this.MathUtil = MathUtil;
    this.$filter = $filter;
    this.tableData = {};

    this.WEEK = ['日', '月', '火', '水', '木', '金', '土'];

    $scope.$watch('$ctrl.data.events', newValue => this.updateEvents(newValue));
    $scope.$watch('$ctrl.data.dailyActivePower', newValue => this.updateDailyActivePower(newValue));
    $scope.$watch('$ctrl.data.dailyMaxDemandPower', newValue => this.updateDailyMaxDemandPower(newValue));
    $scope.$watch('$ctrl.data.demandPower', newValue => this.updateDemandePower(newValue));
  }

  $onInit() {
  }

  updateEvents(events) {
    if (!events) {
      return;
    }
    const currentCount = this.countDemandAlert(events.current);
    const beforeCount = this.countDemandAlert(events.before);
    this.tableData.event = {
      current: currentCount,
      diff: currentCount - beforeCount
    };
  }

  updateDailyActivePower(activePowers) {
    if (!activePowers) {
      return;
    }
    const currentSum = this.sumDailyActivePower(activePowers.current);
    const beforeSum = this.sumDailyActivePower(activePowers.before);
    this.tableData.sumActivePower = {
      current: currentSum,
      diff: this.MathUtil.subtract(currentSum, beforeSum)
    };

    const currentActivePowerMaxDay = this.dailyActivePowerMaxDay(activePowers.current);
    const beforeActivePowerMaxDay = this.dailyActivePowerMaxDay(activePowers.before);
    this.tableData.activePowerMaxDay = {
      current: currentActivePowerMaxDay,
      before: beforeActivePowerMaxDay
    };
  }

  updateDailyMaxDemandPower(demandPowers) {
    if (!demandPowers) {
      return;
    }
    const currentMaxDemandPower = this.maxDailyDemandPower(demandPowers.current);
    const beforeMaxDemandPower = this.maxDailyDemandPower(demandPowers.before);
    this.tableData.demandPowerMax = {
      current: currentMaxDemandPower,
      diff: this.MathUtil.subtract(currentMaxDemandPower, beforeMaxDemandPower)
    };
  }

  updateDemandePower(demandPowers) {
    if (!demandPowers) {
      return;
    }
    const currentDemandPowerMaxTime = this.demandPowerMaxTime(demandPowers.current);
    const beforeDemandPowerMaxTime = this.demandPowerMaxTime(demandPowers.before);
    this.tableData.demandPowerMaxTime = {
      current: currentDemandPowerMaxTime,
      before: beforeDemandPowerMaxTime
    }
  }

  countDemandAlert(eventList) {
    return eventList.filter(e => {
      return e.event_tag.match(/.*_exceeded/);
    }).length;
  }

  sumDailyActivePower(powers) {
    let sum = 0;
    for(let power of powers) {
      sum = this.MathUtil.add(sum, power.value);
    }
    return sum;
  }

  dailyActivePowerMaxDay(powers) {
    const avgs = {};
    if (powers.length === 0) {
      return 'なし';
    }

    for(let day of this.WEEK) {
      avgs[day] = {count: 0, sum: 0};
    }

    for(let power of powers) {
      const day = this.$filter('dayFilter')(power.date);
      if (avgs[day]) {
        avgs[day].count += 1;
        avgs[day].sum += power.value;
      } else {
        avgs[day] = { count: 1, sum: power.value };
      }
    }

    let maxDay = '日';

    for(let key in avgs) {
      if (avgs[maxDay].count === 0) {
        maxDay = key;
        continue;
      }
      if (avgs[key].count === 0) {
        continue;
      }

      const max = avgs[maxDay].sum / avgs[maxDay].count;
      const target = avgs[key].sum / avgs[key].count;

      if (target > max) {
        maxDay = key;
      }
    }

    return maxDay;
  }

  maxDailyDemandPower(powers) {
    const values = powers.map(e => e.value);
    if (values.length === 0) {
      values.push(0);
    }
    return Math.max.apply(null, values);
  }

  demandPowerMaxTime(powers) {
    powers = powers.filter(power => !power.missing);

    if (powers.length === 0) {
      return 'なし';
    }

    const avgs = {};
    for(let power of powers) {
      const timeKey = this.moment(power.measured_at).format('HH:mm');
      if (avgs[timeKey]) {
        avgs[timeKey].count += 1;
        avgs[timeKey].sum += power.value;
      } else {
        avgs[timeKey] = { count: 1, sum: power.value };
      }
    }

    let maxTime = Object.keys(avgs)[0];

    for(let key in avgs) {
      const max = avgs[maxTime].sum / avgs[maxTime].count;
      const target = avgs[key].sum / avgs[key].count;

      if (target > max) {
        maxTime = key;
      }
    }

    return maxTime;
  }
}

export default angular.module('leptonApp.powerStatTable', [moment, MathUtil])
  .component('powerStatTable', {
    template: require('./power-stat-table.html'),
    controller: PowerStatTableController,
    bindings: {
      data: '='
    }
  })
  .name;



// WEBPACK FOOTER //
// ./public/dev/app/statistics_report/power-stat-table/power-stat-table.component.js